import actions from "./actions";

const initialState = {
  user: null,
  token: null,
  loggedIn: false,
  loading: false,
  users: [],
  role: null,
  permissions: [],
  module: null,
  sidebarItems: [],
};

const {
  SET_USER,
  SET_TOKEN,
  SET_LOADING,
  SET_LOGGEDIN,
  SET_USER_LIST,
  SET_ROLE,
  SET_PERMISSION,
  SET_MODULE,
  SET_SIDEBAR_ITEMS,
} = actions;
const UserReducer = (state = initialState, action) => {
  const { type, data } = action;
  switch (type) {
    case SET_USER:
      return {
        ...state,
        user: data,
      };
    case SET_TOKEN:
      return {
        ...state,
        token: data,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: data,
      };
    case SET_LOGGEDIN:
      return {
        ...state,
        loggedIn: data,
      };
    case SET_USER_LIST:
      return {
        ...state,
        users: data,
      };
    case SET_ROLE:
      return {
        ...state,
        role: data,
      };
    case SET_PERMISSION:
      return {
        ...state,
        permissions: data,
      };
    case SET_MODULE:
      return {
        ...state,
        module: data,
      };
    case SET_SIDEBAR_ITEMS:
      return {
        ...state,
        sidebarItems: data,
      };
    default:
      return state;
  }
};

export default UserReducer;
